import { Case } from './Case'
import ProfileType from '@/classes/auth/ProfileType'
import State from './State'

class Auditor {
  constructor (id, name, role, reviewedCases, acceptedCases, issuedCertificates, ongoingCases) {
    this.id = id
    this.role = role
    this.profileType = ProfileType.AUDITOR
    this.name = name
    this.profileTypeDisplay = ProfileType.getProfileTypeDisplay(ProfileType.AUDITOR)
    this.reviewedCases = reviewedCases
    this.acceptedCases = acceptedCases
    this.issuedCertificates = issuedCertificates
    this.ongoingCases = ongoingCases
  }

  static asAuditors (json) {
    console.log(json)
    return json.map(auditor => {
      return Auditor.asAuditor(auditor)
    })
  }

  static asAuditor (json) {
    return new Auditor(
      json.id,
      json.fullname ? json.fullname : json.name,
      json.role ? json.role.charAt(0).toUpperCase() + json.role.slice(1) : '',
      json.reviewed_cases ? json.reviewed_cases : 0,
      json.accepted_cases ? json.accepted_cases : 0,
      json.certificates_issued ? json.certificates_issued : 0,
      json.ongoing_cases ? json.ongoing_cases : 0
    )
  }
}

class AuditorRequest {
  static PENDING = 1
  static ACCEPTED = 2
  static DECLINED = 3

  constructor (id, _case, state, auditor) {
    this.id = id
    this.case = _case
    this.state = state
    this.auditor = auditor
  }

  static asAuditorRequests (json) {
    return json.map(json => {
      return AuditorRequest.asAuditorRequest(json)
    })
  }

  static asAuditorRequest (json) {
    return new AuditorRequest(
      json.id,
      json.case ? Case.asCase(json.case) : null,
      json.state ? State.asState(json.state) : null,
      json.auditor ? Auditor.asAuditor(json.auditor) : null
    )
  }
}

export {
  Auditor,
  AuditorRequest
}
